module.exports = __webpack_public_path__ + "img/homeDone1.cc37fc25.jpg";